export const exportFile = async (
  fileName: string,
  yamlConfig: string
) => {
  try {
    const blob = new Blob([yamlConfig], { type: 'text/yaml' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    alert('YAMLのパースに失敗しました。' + error);
    return;
  }
};